import { SubscriptionDetail } from '@/components/reservations/subscription-detail';

export default SubscriptionDetail;
